export default {
  badge: 'Značka',
  open: 'Otvori',
  close: 'Zatvori',
  dismiss: 'Odbaci',
  confirmEdit: {
    ok: 'U redu',
    cancel: 'Otkaži',
  },
  dataIterator: {
    noResultsText: 'Nijedan zapis nije pronađen',
    loadingText: 'Učitavanje stavki...',
  },
  dataTable: {
    itemsPerPageText: 'Redova po stranici:',
    ariaLabel: {
      sortDescending: 'Sortirano opadajuće.',
      sortAscending: 'Sortirano rastuće.',
      sortNone: 'Nije sortirano.',
      activateNone: 'Klikni da ukloniš sortiranje.',
      activateDescending: 'Klikni da sortiraš opadajuće.',
      activateAscending: 'Klikni da sortiraš rastuće.',
      selectRow: 'Izaberi red',
      selectAll: 'Izaberi sve',
      selectGroup: 'Izaberi grupu',
    },
    sortBy: 'Sortiraj po',
  },
  dataFooter: {
    itemsPerPageText: 'Stavki po stranici:',
    itemsPerPageAll: 'Sve',
    nextPage: 'Sledeća stranica',
    prevPage: 'Prethodna stranica',
    firstPage: 'Prva stranica',
    lastPage: 'Poslednja stranica',
    pageText: '{0}-{1} od {2}',
  },
  dateRangeInput: {
    divider: 'do',
  },
  monthPicker: {
    title: 'Izaberi mesec',
    itemsSelected: '{0} izabrano',
    header: 'Unesite mesec',
    range: {
      title: 'Unesite mesece',
    },
    ariaLabel: {
      previousYear: 'Prethodna godina',
      nextYear: 'Sledeća godina',
      selectYear: 'Izaberi godinu',
      currentMonth: 'Trenutni mesec, {0}',
    },
  },
  datePicker: {
    itemsSelected: '{0} izabrano',
    range: {
      title: 'Izaberite datume',
      header: 'Unesite datume',
    },
    title: 'Izaberite datum',
    header: 'Unesite datum',
    input: {
      placeholder: 'Unesite datum',
    },
    ariaLabel: {
      previousMonth: 'Prethodni mesec',
      nextMonth: 'Sledeći mesec',
      selectYear: 'Izaberi godinu',
      previousYear: 'Prethodna godina',
      nextYear: 'Sledeća godina',
      selectMonth: 'Izaberi mesec',
      selectDate: '{0}',
      currentDate: 'Danas, {0}',
    },
  },
  noDataText: 'Nema dostupnih podataka',
  carousel: {
    prev: 'Prethodna slika',
    next: 'Sledeća slika',
    ariaLabel: {
      delimiter: 'Slika {0} od {1}',
    },
  },
  calendar: {
    moreEvents: '{0} više',
    today: 'Danas',
  },
  heatmap: {
    less: 'Manje',
    more: 'Više',
  },
  input: {
    clear: 'Obriši {0}',
    prependAction: '{0} prethodna radnja',
    appendAction: '{0} sledeća radnja',
    otp: 'Unesite OTP znak {0}',
  },
  fileInput: {
    counter: '{0} fajlova',
    counterSize: '{0} fajlova ({1} ukupno)',
  },
  fileUpload: {
    title: 'Prevucite i otpustite fajlove ovde',
    divider: 'ili',
    browse: 'Pregledaj fajlove',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Izaberite vreme',
    hour: 'Sat',
    minute: 'Minute',
    second: 'Sekunde',
    notAllowed: 'Vrednost nije dozvoljena',
  },
  pagination: {
    ariaLabel: {
      root: 'Navigacija stranicama',
      next: 'Sledeća stranica',
      previous: 'Prethodna stranica',
      page: 'Idi na stranu {0}',
      currentPage: 'Trenutna stranica, stranica {0}',
      first: 'Prva stranica',
      last: 'Poslednja stranica',
    },
  },
  stepper: {
    next: 'Sledeće',
    prev: 'Prethodno',
  },
  rating: {
    ariaLabel: {
      item: 'Ocena {0} od {1}',
    },
  },
  loading: 'Učitavanje...',
  infiniteScroll: {
    loadMore: 'Učitaj još',
    empty: 'Nema više podataka',
  },
  rules: {
    required: 'Ovo polje je obavezno',
    email: 'Unesite važeću e-mail adresu',
    number: 'Ovo polje može sadržati samo brojeve',
    integer: 'Ovo polje može sadržati samo cele brojeve',
    capital: 'Ovo polje može sadržati samo velika slova',
    maxLength: 'Morate uneti maksimum {0} karaktera',
    minLength: 'Morate uneti minimum {0} karaktera',
    strictLength: 'Dužina unetog polja nije važeća',
    exclude: 'Karakter {0} nije dozvoljen',
    notEmpty: 'Izaberite bar jednu vrednost',
    pattern: 'Nevažeći format',
  },
  command: {
    search: 'Unesite naredbu ili pretražite...',
  },
  hotkey: {
    then: 'zatim',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Strelica gore',
    downArrow: 'Strelica dole',
    leftArrow: 'Strelica levo',
    rightArrow: 'Strelica desno',
    backspace: 'Backspace',
    space: 'Razmak',
    plus: 'plus',
    shortcut: 'Prečica na tastaturi: {0}',
    or: 'ili',
  },
  video: {
    play: 'Reprodukuj',
    pause: 'Pauziraj',
    seek: 'Traži',
    volume: 'Jačina zvuka',
    showVolume: 'Prikaži kontrolu jačine zvuka',
    mute: 'Isključi zvuk',
    unmute: 'Uključi zvuk',
    enterFullscreen: 'Prikaz preko cijelog ekrana',
    exitFullscreen: 'Izađi iz prikaza preko cijelog ekrana',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Izaberite boju sa ekrana',
      hueSlider: 'Nijansa',
      alphaSlider: 'Alfa',
      redInput: 'Crvena',
      greenInput: 'Zelena',
      blueInput: 'Plava',
      alphaInput: 'Alfa',
      hueInput: 'Nijansa',
      saturationInput: 'Zasićenost',
      lightnessInput: 'Svetlina',
      hexInput: 'HEX vrednost',
      hexaInput: 'HEX sa alfa vrednošću',
      changeFormat: 'Promeni format boje',
    },
  },
}
